// extracted by mini-css-extract-plugin
module.exports = {"container":"article_container__IZRw2","accessDenied":"article_accessDenied__vLG5m","icon":"article_icon__aZkr2","read-checkbox":"article_read-checkbox__PYCJr"};